const Maintance = () => {
    return(
        <div>
            <h1 className="text-center"> Page is currecny down for maintance. Please come back at a later time.</h1>
            <h3 className="text-center"> Thanks TKI Team</h3>
        </div>
    )
}

export default Maintance